import { lazy, useMemo, Suspense } from 'react';
import { useUpMedia } from '../hooks';
import { LoadingSpinner } from '../components/spinners';

const DesktopB2CBlockchainHistory = lazy(() =>
  import('../components/b2c-blockchain-history/desktop/DesktopB2CBlockchainHistory.tsx').then(
    (module) => ({
      default: module.DesktopB2CBlockchainHistory,
    })
  )
);

const MobileB2CBlockchainHistory = lazy(() =>
  import('../components/b2c-blockchain-history/mobile/MobileB2CBlockchainHistory.tsx').then(
    (module) => ({
      default: module.MobileB2CBlockchainHistory,
    })
  )
);

const B2CBlockchainHistoryPage = () => {
  const desktop = useUpMedia('md');

  const content = useMemo(
    () => (
      <Suspense
        fallback={
          <LoadingSpinner
            style={{
              margin: 'auto',
            }}
          />
        }
      >
        {desktop ? <DesktopB2CBlockchainHistory /> : <MobileB2CBlockchainHistory />}
      </Suspense>
    ),
    [desktop]
  );

  return content;
};

export { B2CBlockchainHistoryPage };
